import React, { useEffect, useReducer, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IconButton, Button, TextField } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import CustomTextField from '../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import {
  fetchGRERoomList,
  fetchSelectedRoom,
  greGlobalDefaultTabSelector,
} from '../../../layouts/configurations/configurationSlice';
import { selectedHotelSelector } from '../../../layouts/property/propertySlice';
import { formDataValidate } from '../../../utils/formUtils';
import { RemoveCircleRounded } from '@material-ui/icons';
import { saveOrUpdateRoomConfigs } from '../../../utils/IntegrationsAPIUtils';
import { notificationManager } from '../../../utils/NotificationUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../utils/loaderSlice';

const GuestRoomExperienceRoomTabDoorLockEdit = (props) => {
  const { toggleDrawer, doorLockInfo, roomId, showLoader = () => {} } = props;
  const dispatch = useDispatch();
  const data = useSelector(greGlobalDefaultTabSelector);
  const selectedHotel = useSelector(selectedHotelSelector);
  const [nameLanguages, setNameLanguages] = useState([]);
  const [deviceSpecificAttributes, setDeviceSpecificAttributes] = useState([]);
  const [isAddingPair, setAddingPair] = useState(false);
  const [attributes, setAttributes] = useState([]);
  const [nameAliases, setNameAliases] = useState([]);
  const [additionalInfo, setAdditionalInfo] = useState({
    index: null,
    field: '',
    value: '',
    code: '',
  });

  const vendor = vendor;
  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    vendor: {
      value: '',
      fieldName: 'Vendor',
      errors: {},
      validations: ['required'],
    },
    name: {
      value: '',
      fieldName: 'Door Lock Name',
      errors: {},
      validations: ['required'],
    },
    id: {
      value: '',
      fieldName: 'Door Lock Id',
      errors: {},
      validations: ['required'],
    },
  });

  useEffect(() => {
    if (data) {
      setNameLanguages(
        data.languages.map((language) => {
          return {
            languageCode: language.languageCode,
            languageName: language.languageName,
          };
        }),
      );
    }
  }, [data]);

  useEffect(() => {
    if (doorLockInfo) {
      const currFields = { ...formData };
      for (let field in currFields) {
        if (field === vendor) {
          currFields[vendor].value = doorLockInfo?.[vendor]?.name;
          setAttributes(doorLockInfo[vendor]?.attributes);
          setDeviceSpecificAttributes(
            doorLockInfo?.[vendor]?.controlSpecificAttributes?.map((attr) => {
              return {
                field: attr?.key,
                value: attr?.value,
              };
            }),
          );
        } else {
          currFields[field].value = doorLockInfo[field];
        }
      }
      setFormData(currFields);
      if (doorLockInfo.nameAliases.length > 1) {
        setNameAliases(doorLockInfo.nameAliases);
      }
    }
  }, [doorLockInfo]);

  const validate = (isUpdatedFields) => {
    const updatedFields = {};
    const isValid = formDataValidate(formData, isUpdatedFields ? updatedFields : isUpdatedFields);
    if (isUpdatedFields) setFormData(updatedFields);
    return isValid;
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      dispatch(stepUpLoaderCount());
      if (!validate(true)) return false;
      const payload = {};
      for (let field in formData) {
        payload[field] = formData[field].value;
      }
      const vendor = { ...doorLockInfo.vendor };
      const addAttributes = deviceSpecificAttributes?.map((attributesValue) => {
        return { key: attributesValue?.field, value: attributesValue?.value };
      });
      payload.nameAliases = nameAliases;
      vendor.controlSpecificAttributes = addAttributes;
      vendor.attributes = attributes;
      payload.vendor = vendor;
      payload.status = doorLockInfo.status;
      await saveOrUpdateRoomConfigs(selectedHotel, roomId, 'DoorLock', payload);
      notificationManager('success', 'Door Lock details updated successfully');
      dispatch(fetchGRERoomList(selectedHotel));
      dispatch(fetchSelectedRoom(selectedHotel, roomId));
      toggleDrawer('', false, '');
    } catch (error) {
      if (error?.message) {
        notificationManager('danger', error?.message);
      } else {
        notificationManager('danger', 'Unable to update Door Lock details');
      }
    } finally {
      dispatch(stepDownLoaderCount());
    }
  };

  const onCancel = (e) => {
    toggleDrawer('', false, '');
  };

  const handleInfoInputChange = (e, type) => {
    const inputValue = e.target.value;
    setAdditionalInfo((prev) => ({
      ...prev,
      [type]: inputValue,
    }));
  };

  const onInfoAdd = () => {
    if (isAddingPair) {
      if (additionalInfo.value && additionalInfo.field) {
        const infoArray = deviceSpecificAttributes?.length ? [...deviceSpecificAttributes] : [];
        const info = additionalInfo;
        if (info.code) {
          info.value = '+' + info.code + '_' + info.value.substr(info.code.length + 1);
        }
        info.index = infoArray.length + 1;
        delete info.code;
        infoArray.push(info);
        setDeviceSpecificAttributes(infoArray);
        setAdditionalInfo({ index: null, field: '', value: '' });
      }
    } else {
      setAddingPair(true);
    }
  };

  const onInfoDelete = (index) => {
    const attributeArray = [...deviceSpecificAttributes];
    attributeArray.splice(index, 1);
    setDeviceSpecificAttributes(attributeArray);
  };

  const onAttributeEdit = (attribute, value) => {
    let tempAttributes = [...attributes];
    setAttributes(
      tempAttributes.map((atr) => {
        return {
          key: atr?.key,
          value: atr?.key === attribute?.key ? value?.target?.value : atr?.value,
        };
      }),
    );
  };

  const onNameAliasesEdit = (alias, value) => {
    let tempNameAlliases = [...nameAliases];
    setNameAliases(
      tempNameAlliases?.map((tempAlias) => {
        return {
          languageId: tempAlias?.languageId,
          alias:
            tempAlias?.languageId === alias?.languageId ? value?.target?.value : tempAlias?.alias,
        };
      }),
    );
  };

  return (
    <form onSubmit={handleSubmit} className='category-create' noValidate>
      <div className='container pt-4 d-flex flex-column '>
        <div className='row px-3 w-100 mt-4 form-scroll' style={{ maxHeight: '100%' }}>
          <div className='col-md-6'>
            <span className='page-title'>Edit Door lock: {doorLockInfo?.name}</span>
          </div>
          <div className='col-md-6 d-flex justify-content-end'>
            <IconButton aria-label='delete' onClick={(e) => onCancel(e)}>
              <CancelIcon />
            </IconButton>
          </div>
          <div className='row'>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.vendor}
                handleInputChange={(e) => {
                  setFormData({ vendor: e });
                }}
                disabled={true}
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.name}
                handleInputChange={(e) => {
                  setFormData({ name: e });
                }}
                maxLength={30}
                endAdornment={true}
                characterCount={true}
              />
            </div>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.id}
                handleInputChange={(e) => {
                  setFormData({ id: e });
                }}
              />
            </div>
          </div>
          {nameAliases.map((alias, key) => (
            <div className='col-md-6 mb-3' key={key}>
              <TextField
                className='col-md-12 pe-0'
                id='language-name-field'
                label={
                  'Light Name (' +
                  nameLanguages?.find((lang) => lang?.languageCode === alias?.languageId)
                    .languageName +
                  ')'
                }
                value={alias?.alias}
                onChange={(e) => onNameAliasesEdit(alias, e)}
              />
            </div>
          ))}
          <div className='row px-3'>
            {attributes?.map((attribute, key) => (
              <div className='col-md-6 mb-3' key={key}>
                <TextField
                  className='col-md-12 pe-0'
                  id='language-name-field'
                  value={attribute?.value}
                  label={attribute?.key}
                  onChange={(e) => onAttributeEdit(attribute, e)}
                />
              </div>
            ))}
          </div>
          <h4 className='tab-title mt-4'>Key Value Pair</h4>
          {isAddingPair && (
            <div className='row'>
              <div className='col-md-6 mb-3'>
                <TextField
                  id='additional-info-field'
                  label='Enter Label Name'
                  className='col-md-12'
                  value={additionalInfo.field}
                  onChange={(e) => handleInfoInputChange(e, 'field', false)}
                  required={isAddingPair}
                />
              </div>
              <div className='col-md-6 mb-3'>
                <TextField
                  id='additional-info-value'
                  label='Field Value'
                  className='col-md-12'
                  value={additionalInfo.value}
                  onChange={(e) => handleInfoInputChange(e, 'value', true)}
                  required={isAddingPair}
                />
              </div>
            </div>
          )}
          <div className='row'>
            <div className='col-md-12 mb-3'>
              <Button
                variant='outlined'
                color={additionalInfo?.value && additionalInfo?.field ? 'primary' : 'secondary'}
                disabled={isAddingPair && (!additionalInfo?.value || !additionalInfo?.field)}
                onClick={onInfoAdd}
              >
                Add
              </Button>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-12 mb-3 drag-item'>
              {deviceSpecificAttributes.map((item, index) => (
                <div className='row' key={index}>
                  <div className='col-md-6'>
                    <TextField
                      id='additional-info-field-edit'
                      className='col-md-6'
                      label={item.field}
                      value={item.value}
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  </div>
                  <div className='col-md-6 d-flex justify-content-end'>
                    <RemoveCircleRounded
                      onClick={(e) => onInfoDelete(index)}
                      className='additional-info-remove'
                      color='secondary'
                    ></RemoveCircleRounded>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className='row mx-2 mt-auto px-4 w-100 pb-5'>
          <div className='col-md-12 d-flex justify-content-start'>
            <Button
              variant='contained'
              type='submit'
              color='primary'
              className='me-3'
              size='large'
              disabled={!validate(false)}
            >
              Update
            </Button>
            <Button
              variant='outlined'
              type='button'
              color='secondary'
              size='large'
              onClick={(e) => onCancel(e)}
            >
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default GuestRoomExperienceRoomTabDoorLockEdit;
